import { z } from "zod";

//#region Member Widget
export const MemberWidgetSchema = z.object({
  filterOptions: z.coerce.number({
    message: "Select One",
    required_error: "Select One",
  }),
});
export type IMemberWidgetSchema = z.infer<typeof MemberWidgetSchema>;

export interface IMemberResult {
  tabularResult: IMemberTabularChartResult[];
  chartResult: IMemberTabularChartResult[];
}

export type IMemberTabularChartResult = {
  title: string;
  count: number;
};
//#endregion

//#region Visitors Widget
export interface IVisitorResult {
  todayVisitors: number;
  last7DaysVisitors: number;
  lastMonthVisitors: number;
}
//#endregion

//#region Material Widget

export interface IMaterialResults {
  instituteWiseMaterial: IInstituteWiseMaterialResult[];
  materialTypeWiseMaterial: IMaterialTypeWiseMaterialResult[];
  availableIssuedMaterial: IAvailableIssuedMaterialResult;
  materialStatusWiseMaterial: IMaterialStatusWiseMaterialResult[];
}

export type IInstituteWiseMaterialResult = {
  instituteID: string | number;
  instituteName: string;
  title: number;
  volume: number;
  totalTitle?: number;
  totalVolume?: number;
};

export type IMaterialTypeWiseMaterialResult = {
  materialTypeID: string | number;
  materialTypeName: string;
  title: number;
  volume: number;
  pendingRackAssignment: number;
  totalPendingRackAssignment: number;
};

export type IAvailableIssuedMaterialResult = {
  availableBooks: number;
  issuedBooks: number;
};

export type IMaterialStatusWiseMaterialResult = {
  materialStatusID: string | number;
  materialStatusName: string;
  volume: number;
};

//#endregion

//#region Circulation Widget

export interface ICirculationResult {
  memberTypeWiseIssuedOverDue: ICirculationIssueOverdueResult[];
  materialTypeWiseIssuedOverDue: ICirculationIssueOverdueResult[];
}

export type ICirculationIssueOverdueResult = {
  id: string | number;
  name: string;
  issued: number;
  overdue: number;
};
//#endregion
